// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"367": "3ef40d476b114e0f","608": "f8253802f0c4b0e6","633": "33c47d915c599617","956": "2c6fcfc9d70521b4",}[chunkId] + ".js"
}